import { gramsToMatch } from '../../utils/foodEdit';
import { oneDecimal } from '../../utils/portions';

import { DIET_FOODS, DIET_LUNCHES, DIET_SWAPS } from './landingData';

/*
 * The Plano alimentar demo's moves, kept apart from the drawing: the lunch, "Trocar refeição" bringing the next
 * prepared one, a food swapped for a database food with the grams that give its calories (the app's own rounding,
 * utils/foodEdit), and one undo for the last of either. No AI and no network: everything is prepared data.
 */

/** A meal entry ({ id, grams, spoons?, fromDb? }) with its name in the language, its calories and its macros. */
export const foodOf = (entry, language) => {
  const food = DIET_FOODS[entry.id];
  const [kcal, protein, carbs, fat] = food.per100.map((value) => (value * entry.grams) / 100);
  return {
    ...entry,
    kind: food.kind,
    name: (entry.fromDb ? food.db : food.plan)[language],
    kcal: Math.round(kcal),
    protein: oneDecimal(protein),
    carbs: oneDecimal(carbs),
    fat: oneDecimal(fat),
  };
};

/** The meal's calories as the plan adds them (each food's, rounded) and its macros, rounded once at the end. */
export const totalsOf = (foods) => {
  const sum = (key) => foods.reduce((total, food) => total + food[key], 0);
  return { kcal: sum('kcal'), protein: Math.round(sum('protein')), carbs: Math.round(sum('carbs')), fat: Math.round(sum('fat')) };
};

/**
 * The database foods offered in place of the entry: its kind's list, without itself or what's already in the meal,
 * each weighed to the entry's calories (5 g steps, 10 g from 100 g, as the app's food editor does).
 */
export const swapOptions = (entry, meal) => {
  const { kcal } = foodOf(entry, 'pt');
  return DIET_SWAPS[DIET_FOODS[entry.id].kind]
    .filter((id) => id !== entry.id && !meal.some((other) => other.id === id))
    .slice(0, 3)
    .map((id) => ({ id, grams: gramsToMatch(DIET_FOODS[id].per100[0], kcal), fromDb: true }));
};

export const startDiet = () => ({ lunch: 0, foods: DIET_LUNCHES[0], undo: null });

export const dietStep = (state, action) => {
  const before = { lunch: state.lunch, foods: state.foods };
  switch (action.type) {
    case 'swapMeal': {
      const lunch = (state.lunch + 1) % DIET_LUNCHES.length;
      return { lunch, foods: DIET_LUNCHES[lunch], undo: before };
    }
    case 'swapFood':
      return { ...state, foods: state.foods.map((entry, index) => (index === action.index ? action.entry : entry)), undo: before };
    case 'undo':
      return state.undo ? { ...state.undo, undo: null } : state;
    default:
      return state;
  }
};
